import React, { useState, useRef } from 'react';
import { usePlacesWidget } from 'react-google-autocomplete';

// import TextField from '@material-ui/core/TextField';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';

import { constants } from 'utils/constants';
import { countries } from 'data/Countries';

import { useStyles } from './Style';

type SearchProps = {
	onSearch: ({
		lat,
		lng,
	}: {
		lat: string | number;
		lng: string | number;
	}) => void;
};

const Search: React.FC<SearchProps> = ({ onSearch }): JSX.Element => {
	const classes = useStyles();
	const placeRef = useRef(null);
	const [country, setCountry] = useState('IN');

	const onPlaceSelect = (place: any) => {
		if (place?.geometry?.location) {
			const lat = place.geometry.location.lat();
			const lng = place.geometry.location.lng();
			onSearch({ lat, lng });
		}
	};

	const { ref: materialRef } = usePlacesWidget({
		apiKey: `${constants('GOOGLE_MAPS_API_KEY')}`,
		onPlaceSelected: (place: any) => {
			placeRef.current = place;
			onPlaceSelect(place);
		},
		inputAutocompleteValue: 'country',
		options: {
			types: ['establishment'],
			componentRestrictions: { country: country?.toLowerCase() },
		},
	});

	const handlePlaceChange = (e: any) => {
		if (e.key === 'Enter' && placeRef.current !== null) {
			onPlaceSelect(placeRef.current);
		} else {
			placeRef.current = null;
		}
	};

	const handleCountryChange = (event: any) => {
		setCountry(event.target.value);
	};

	return (
		<div className={classes.searchContainer}>
			<div className={classes.countryDropDown}>
				<div className={classes.rowAlign}>
					<TextField
						id="outlined-select-country"
						select
						fullWidth
						size="small"
						value={country}
						label=""
						onChange={handleCountryChange}
						variant="outlined"
					>
						{countries.map((option) => (
							<MenuItem key={option.id} value={option.id}>
								{option.name}
							</MenuItem>
						))}
					</TextField>
					<TextField
						size="small"
						color="primary"
						variant="outlined"
						style={{ backgroundColor: '#fff', width: '500px' }}
						inputRef={materialRef}
						onKeyUp={handlePlaceChange}
					/>
				</div>
			</div>
		</div>
	);
};

export default Search;
